import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronLeftIcon, ChevronRightIcon } from "lucide-react";
const contentSlides = [{
  src: "https://cdn.magicpatterns.com/uploads/foqzJ4DBRJxfgwhxkJvW5T/Screenshot_2026-07-20_at_10.54.55_PM.png",
  alt: "Criterios de derivación urgente para fisioterapeutas",
  label: "Guía rápida · Derivación urgente"
}, {
  src: "https://cdn.magicpatterns.com/uploads/7vykteDG3UvT3UaYtuJiGs/Screenshot_2026-07-20_at_10.58.02_PM.png",
  alt: "Escala FAAM de pie y tobillo con actividades de la vida diaria",
  label: "Escala de valoración · FAAM"
}, {
  src: "https://cdn.magicpatterns.com/uploads/2CXFPzUFfSPkJhkrh5zJ2J/Screenshot_2026-07-20_at_11.00.56_PM.png",
  alt: "Caso clínico de cervicalgia mecánica con exploración y razonamiento",
  label: "Caso clínico · Cervicalgia"
}, {
  src: "https://cdn.magicpatterns.com/uploads/w5PaDTuLuppkGFNhnx5MY4/Screenshot_2026-07-20_at_11.01.30_PM.png",
  alt: "Evidencia en el tratamiento de la fascitis plantar",
  label: "Caso clínico · Fascitis plantar"
}, {
  src: "https://cdn.magicpatterns.com/uploads/jC3xbreSo3r7UR7vMUtsxW/Vista_previa.png",
  alt: "Checklist de banderas rojas cervicales",
  label: "Checklist · Banderas rojas"
}, {
  src: "https://cdn.magicpatterns.com/uploads/3C2JDepo3BPyHr6mS2zT9g/Vistazo.png",
  alt: "Caso clínico de tenosinovitis de De Quervain",
  label: "Caso clínico · De Quervain"
}, {
  src: "https://cdn.magicpatterns.com/uploads/63LWNh4E7rWvEjjpPEak7M/Vistazo_2.png",
  alt: "Protocolo de tratamiento de la radiculopatía lumbar",
  label: "Protocolo · Radiculopatía lumbar"
}];
export function Reviews() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [dragStart, setDragStart] = useState<number | null>(null);
  const activeSlide = contentSlides[activeIndex];
  function showPrevious() {
    setActiveIndex(current => (current - 1 + contentSlides.length) % contentSlides.length);
  }
  function showNext() {
    setActiveIndex(current => (current + 1) % contentSlides.length);
  }
  function handleDragEnd(event: React.PointerEvent<HTMLDivElement>) {
    if (dragStart === null) return;
    const delta = event.clientX - dragStart;
    if (delta > 45) showPrevious();
    if (delta < -45) showNext();
    setDragStart(null);
  }
  return <section className="px-4 pt-12" data-id="element-163" data-mp="13ed6ga9f8juw">
      <div className="mx-auto max-w-md" data-id="element-164" data-mp="13dbkvbus4eyx">
        <h2 className="text-center font-display text-xl font-extrabold text-slate-900" data-id="element-165" data-mp="18dzm0qcq2c6v">
          Échale un vistazo al contenido
        </h2>
        <p className="mt-1 text-center text-sm text-slate-500" data-id="element-166" data-mp="thrzhjducyof">
          Material profesional listo para tu consulta.
        </p>

        <div className="mt-5 overflow-hidden rounded-3xl border border-slate-200 bg-white shadow-md" data-id="element-167" data-mp="yhw8ypgc0t55">
          <div className="relative aspect-[4/5] touch-pan-y bg-slate-100" onPointerDown={event => setDragStart(event.clientX)} onPointerUp={handleDragEnd} onPointerCancel={() => setDragStart(null)} data-id="element-168" data-mp="2nsn7okl46bqo">
            <AnimatePresence mode="wait" data-id="element-169" data-mp="c8fstdr6kzv8">
              <motion.img key={activeSlide.src} src={activeSlide.src} alt={activeSlide.alt} initial={{
              opacity: 0,
              x: 24
            }} animate={{
              opacity: 1,
              x: 0
            }} exit={{
              opacity: 0,
              x: -24
            }} transition={{
              duration: 0.2,
              ease: "easeOut"
            }} className="h-full w-full select-none object-cover" draggable={false} data-id="element-170" data-mp="c5jqld8avp0z" />
            </AnimatePresence>

            <button type="button" onClick={showPrevious} className="absolute left-3 top-1/2 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full bg-white/90 text-slate-700 shadow-md transition-transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-teal-500" aria-label="Ver contenido anterior" data-id="element-171" data-mp="19t293frrk5i6">
              <ChevronLeftIcon className="h-5 w-5" data-id="element-172" data-mp="386oo5j35hs2d" />
            </button>
            <button type="button" onClick={showNext} className="absolute right-3 top-1/2 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full bg-white/90 text-slate-700 shadow-md transition-transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-teal-500" aria-label="Ver siguiente contenido" data-id="element-173" data-mp="3d2do3nj31az7">
              <ChevronRightIcon className="h-5 w-5" data-id="element-174" data-mp="2udyzt805gb23" />
            </button>

            <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-slate-950/60 to-transparent px-4 pb-3 pt-10" data-id="element-175" data-mp="2zbqug9s6ib9z">
              <p className="text-sm font-bold text-white" data-id="element-176" data-mp="343sa85ok2k4r">{activeSlide.label}</p>
            </div>
          </div>

          <div className="flex items-center justify-between px-4 py-3" data-id="element-177" data-mp="26ncrrgq5aqs3">
            <p className="text-xs font-medium text-slate-500" data-id="element-178" data-mp="2blo35vw399cf">Desliza para ver más ejemplos</p>
            <div className="flex gap-1.5" aria-label={`Diapositiva ${activeIndex + 1} de ${contentSlides.length}`} data-id="element-179" data-mp="sqjvkuv1kry9">
              {contentSlides.map((slide, index) => <button key={slide.src} type="button" onClick={() => setActiveIndex(index)} className={`h-1.5 rounded-full transition-all focus:outline-none focus:ring-2 focus:ring-teal-500 ${index === activeIndex ? "w-4 bg-teal-600" : "w-1.5 bg-slate-300"}`} aria-label={`Ir a ${slide.label}`} aria-current={index === activeIndex ? "true" : undefined} data-id="element-180" data-mp="jqn0obi26wur" data-mpi={index} />)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}